import axios from 'axios';
import { ref } from 'vue';
import { toast } from 'vue-sonner';
import { useI18n } from 'vue-i18n';

/**
 * Starts an export built on a queue and mailed: there is nothing to download, the
 * request only says it started.
 */
export function useQueuedExport() {
  const { t } = useI18n();
  const running = ref(false);

  async function start(url: string): Promise<boolean> {
    if (running.value || !url) {
      return false;
    }

    running.value = true;

    try {
      const { data } = await axios.get(url);
      toast.success(data.message);

      return true;
    } catch (error) {
      toast.error(t('The export could not be started.'));

      return false;
    } finally {
      running.value = false;
    }
  }

  return { running, start };
}
